import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { OrdineVendita } from '../../_models/OrdineVendita';
import { CampoUtenteDef } from '../../_models/CampoUtenteDef';
import { SaleOrdiniService } from '../../_services/sale-ordini.service';
import {
  getStatoConsegnaClass,
  getStatoConsegnaLabel,
  getStatoOrdineBorderClass,
  getStatoOrdineClass,
  getStatoOrdineLabel,
  getStatoRowBackgroundClass,
} from '../../_helpers/stato-ordine-vendita.helper';
import {
  OvListColumn,
  formatOvCellValue,
  resolveOvColumn,
} from '../../_models/ordine-vendita-list-columns';

@Component({
  selector: 'app-ordine-vendita-row',
  templateUrl: './ordine-vendita-row.component.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrdineVenditaRowComponent implements OnInit, OnDestroy {
  @Input() ordine!: OrdineVendita;
  @Input() visibleColumns: readonly string[] = [];
  @Input() gridTemplate = '';
  // Feature 064 — definizioni Campi Utente attive, inoltrate alle celle desktop e usate dal
  // render generico delle card mobile per le colonne `Cu_<codice>`.
  @Input() campiUtenteDefinizioni: CampoUtenteDef[] = [];

  @Output() ordineSelected = new EventEmitter<OrdineVendita>();
  @Output() ordineDeleted = new EventEmitter<OrdineVendita>();

  readonly getStatoLabel = getStatoOrdineLabel;
  readonly getStatoClass = getStatoOrdineClass;
  readonly getStatoBorderClass = getStatoOrdineBorderClass;
  readonly getConsegnaLabel = getStatoConsegnaLabel;
  readonly getConsegnaClass = getStatoConsegnaClass;
  readonly getRowBackgroundClass = getStatoRowBackgroundClass;

  // Feature 064 — render generico card mobile (`*ngSwitchDefault`). resolveOvColumn risolve
  // anche le colonne dinamiche `Cu_<codice>` dalle definizioni Campi Utente (altrimenti "-").
  getMeta(col: string): OvListColumn | undefined {
    return resolveOvColumn(col, this.campiUtenteDefinizioni);
  }

  formatCell(col: string): string {
    const meta = resolveOvColumn(col, this.campiUtenteDefinizioni);
    return meta ? formatOvCellValue(this.ordine, meta, this.campiUtenteDefinizioni) : '-';
  }

  private subscription?: Subscription;

  constructor(
    private saleOrdiniService: SaleOrdiniService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    // Il salvataggio OdV è asincrono (202 + coda RabbitMQ): quando il worker conferma via
    // SignalR, la riga si riallinea ai dati persistiti (fix valori stantii post-save).
    // Pattern OrdineLocalItemComponent (Ordini Produzione); markForCheck necessario per OnPush.
    this.subscription = this.saleOrdiniService.lastOrdineVenditaUpdated.subscribe(o => {
      if (!o || o.hasErrors) return; // BehaviorSubject(null) iniziale + payload d'errore
      if (this.ordine.organizzazioneId === o.organizzazioneId &&
          this.ordine.idOrdineVendita === o.idOrdineVendita &&
          this.ordine.idRiga === o.idRiga) {
        this.ordine = o;
        this.cdr.markForCheck();
      }
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
